export const JOTFORM_SUPPORT_URL = 'https://hipaa-submit.jotform.com/233186747598070';
export const JOTFORM_VERIFIABLE_MISSING_FORM_URL = 'https://form.jotform.com/250708067325052';
